import { Injectable } from "@angular/core";
import { ReferenceDrawerItemInfo } from "@shared/models/reference-drawer-item-info.model";
import { Source } from "@shared/models/message.model";
import { ReferenceDrawerState } from "@app/shared/models/reference-drawer-state.model";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ReferenceDrawerService {
    private _referenceState = new Subject<ReferenceDrawerState>();

    get referenceState(): Observable<ReferenceDrawerState> {
        return this._referenceState.asObservable();
    }

    showReferences(sources: Source[]): void {
        this._referenceState.next({ visible: true, sources });
    }

    clearReferences(): void {
        this._referenceState.next({ visible: false, sources: [] });
    }

    toReferenceItems(sources: Source[]): ReferenceDrawerItemInfo[] {
        return sources.map(source => {
            const item: ReferenceDrawerItemInfo = {
                url: source.url,
                title: source.title,
                type: source.type,
                extension: '',
                pageReference: ''
            };

            if (source.type === 'ASK_MY_DOCS') {
                const properties = this.getPropertiesFromSource(source);
                item.title = properties.name;
                item.extension = properties.extension;
                item.pageReference = properties.pageReference;
            }

            return item;
        });
    }

    private getPropertiesFromSource(source: Source): {
        name: string,
        extension: string,
        pageReference: string
    } {
        const parts = source.title.split('.');
        const name = parts.slice(0, -1).join('.').replace(/_/g, ' ').trim();

        const url = new URL(source.url);

        let pageReference = url.searchParams.get('page');
        pageReference = pageReference ? `pp. ${pageReference}` : '';

        const extension = parts.length > 1 ? parts[parts.length - 1] : '';

        return {
            extension: extension.toUpperCase(),
            name,
            pageReference
        };
    }
};
